import * as Highcharts from "highcharts/highstock";
// lollipop chart
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsDumbbell from "highcharts/modules/dumbbell";
import HighchartsLollipop from "highcharts/modules/lollipop";
// print and export
import HighchartsExporting from "highcharts/modules/exporting";
// gap in charts
import BrokenAxis from "highcharts/modules/broken-axis";

import * as TimeUtils from "./time";

export const setupHighcharts = (): void => {
	BrokenAxis(Highcharts);
	HighchartsMore(Highcharts);
	HighchartsDumbbell(Highcharts);
	HighchartsLollipop(Highcharts);
	HighchartsExporting(Highcharts);
	Highcharts.setOptions({
		chart: {
			style: {
				fontFamily: "var(--sw-font-family)",
			},
		},
	});
	Highcharts.Chart.prototype["graphLayoutsLookup"] = []; // workaround for Print Chart. bug in v 8.1.0
	Highcharts.dateFormats["Custom"] = time => "<b>Local Time: </b>" + TimeUtils.format(time, "D MMMM YYYY HH:mm:ss") + "<br/><b>UTC: </b> " + TimeUtils.formatUTC(time, "D MMMM YYYY HH:mm:ss");
	Highcharts.Pointer.prototype.reset = () => undefined;
};
